
  import { Component, Vue } from 'vue-property-decorator';
  
  @Component
  export default class DataProtectionDeclaration extends Vue {
  
    public cancel() {
      this.$router.back();
    }
  
  }
  